module.exports = __webpack_public_path__ + "img/kiosk-specifications-en.3c885218.png";